import {
  SKIP,
  custom,
  deserialize,
  object,
  optional,
  serializable,
} from 'serializr';
import { PageObject } from '@testsigmainc/models';
import { Base } from '@models/base.model';
import { SalesforceObjectFieldPicklistValues } from './salesfroce-object-field-pick-list-values.model';

export class SalesforceObjectField extends Base implements PageObject {
  @serializable
  public name: string;
  @serializable
  public label: string;
  @serializable
  public nillable: boolean;
  @serializable
  public isCustom: boolean;
  @serializable
  public length: number;
  @serializable
  public sortable: boolean;
  @serializable
  public filterable: boolean;
  @serializable
  public groupable: boolean;
  @serializable
  public updateable: boolean;
  @serializable
  public unique: boolean;
  @serializable
  public compoundFieldName: string;
  @serializable
  public metadataObjectId: number;
  @serializable
  public type: any;
  @serializable
  public fieldDefinitionId: number;
  @serializable
  public defaultedOnCreate: boolean;

  @serializable(
    optional(
      custom(
        () => SKIP,
        (v) => v,
      ),
    ),
  )
  public salesforceObjectFieldPicklistValues: SalesforceObjectFieldPicklistValues[];

  public sortableFieldName: string;

  @serializable
  public referenceObjectName: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(SalesforceObjectField, input));
  }
}
